import { PrePublicPortalWlFormService } from "@prePublicPortalWestLindsay/services/PrePublicPortalWlFormService";
import { H1, LeadParagraph, LoadingBox, Main, Panel } from "govuk-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router";

const service = new PrePublicPortalWlFormService();
export const PrePublicPortalWlPaymentsSuccess = () => {
    const { uuid } = useParams<{ uuid: string }>();
    const [loading, setLoading] = useState(true);
    const [paymentError, setPaymentError] = useState<string | undefined>(undefined);
    const [paymentSuccess, setPaymentSuccess] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (uuid) {
            service.checkPayment(uuid).then((res) => {
                setLoading(false);
                setPaymentError(res.errorMsg ? "Your payment session has expired. This may be because you have completed your payment or your session has timed out." : undefined);
                setPaymentSuccess(res.informationMsg);
            });
        } else {
            setLoading(false);
        }
    }, [uuid]);

    if (loading) {
        return (
            <LoadingBox loading={loading}>
                <h1>Checking payment...</h1>
            </LoadingBox>
        );
    }
    const lines = paymentSuccess?.split(",").map((line, index) => <p key={index}>{line.trim()}</p>);
    return !paymentError ? (
        <Panel title="Payment successful">
            <Main>{lines}</Main>
        </Panel>
    ) : (
        <Main>
            <H1>Your payment link has expired</H1>
            <LeadParagraph>{paymentError}</LeadParagraph>
        </Main>
    );
};
